import { OptionalRedirect } from "./optional-redirect";
import { RequestAssistance } from "./request-assistance";

export default function StorylineMenu(props: any) {
    return <>
        <RequestAssistance />
        <OptionalRedirect />
    </>;
}